import { Grid, Box, Typography, CircularProgress } from '@mui/material'

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DescriptionIcon from '@mui/icons-material/Description'
import ImageIcon from '@mui/icons-material/Image'
import TableChartIcon from '@mui/icons-material/TableChart'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'

const getIcon = (nomeArquivo) => {
  const ext = nomeArquivo?.split('.').pop()?.toLowerCase()

  switch (ext) {
    case 'pdf':
      return <PictureAsPdfIcon color="error" sx={{ fontSize: 40 }} />

    case 'doc':
    case 'docx':
      return <DescriptionIcon color="primary" sx={{ fontSize: 40 }} />

    case 'xls':
    case 'xlsx':
      return <TableChartIcon color="success" sx={{ fontSize: 40 }} />

    case 'jpg':
    case 'jpeg':
    case 'png':
      return <ImageIcon color="secondary" sx={{ fontSize: 40 }} />

    default:
      return <InsertDriveFileIcon sx={{ fontSize: 40 }} />
  }
}

export default function FileExplorer({
  arquivos,
  onClickArquivo,
  loadingToken,
  justifyContent = 'flex-end',
}) {
  return (
    <Grid container spacing={2} justifyContent={justifyContent}>
      {arquivos.map((arquivo, index) => {
        const token = arquivo[4]

        return (
          <Grid item key={index}>
            <Box
              onClick={() => onClickArquivo?.(arquivo)}
              sx={{
                width: 100,
                textAlign: 'center',
                cursor: loadingToken ? 'default' : 'pointer',
                opacity: loadingToken && loadingToken !== token ? 0.5 : 1,
                pointerEvents: loadingToken ? 'none' : 'auto',
                p: 1,
                borderRadius: 1,
                position: 'relative',
                transition: '0.2s',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              }}
            >
              {/* ÍCONE OU LOADING */}
              <Box sx={{ position: 'relative', height: 44 }}>
                {loadingToken === token ? (
                  <CircularProgress size={24} />
                ) : (
                  getIcon(arquivo[3])
                )}
              </Box>

              {/* NOME ARQUIVO */}
              <Typography
                noWrap
                sx={{
                  fontSize: 10,
                  mt: 0.5,
                }}
              >
                {arquivo[3]}
              </Typography>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}
